import { TmBaseEvent } from '@/core/events/TmBaseEvent'

export class TmAppLoadedEvent extends TmBaseEvent<void> {
  public static override readonly id = 'TM_EVT_APP_LOADED'

  constructor() {
    super(TmAppLoadedEvent.id, undefined)
  }
}
